import request from '@/utils/request'
const route_reducername = '/reducer/getreducerseriesnamelist'
const route_ratio = '/reducer/getreductionratiolist'
const route_loadcondition = '/reducer/getloadcondition'
const route_motorfactory= '/application/getavailablemotorfactory'
const route_motortype = '/application/getavailablemotortype'
const route_reducersize = '/reducer/getreducerinfo'
const route_factorysize  = '/motor/getmotorinfo'
export function getreducerseriesnamelist() {
  return request.get(route_reducername, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function getreductionratiolist(data) {
  return request.get(route_ratio,{
    headers: {
      'Content-Type': 'application/json'
    },
    params:data
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function getloadcondition(data) {
  var lang = localStorage.getItem('lang');
  data.lang = lang;
  return request.post(route_loadcondition , data , {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function getavailablemotorfactory(data) {
  data.n2m = sessionStorage.getItem('n2m');
  data.T2m = sessionStorage.getItem('T2m');
  data.i = sessionStorage.getItem('i');
  return request.post(route_motorfactory , data , {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function getmotortypelist(data) {
  data.n2m = sessionStorage.getItem('n2m');
  data.T2m = sessionStorage.getItem('T2m');
  data.i = sessionStorage.getItem('i');
  return request.post(route_motortype , data , {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

// 通过减速机型号获取减速尺寸详情
export function getinfobyreducersize(data) {
  return request.post(route_reducersize, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 通过减速机型号得到减速机的所有参数
export function getinfobyfactoryandsize(data) {
  return request.post(route_factorysize, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}



// WEBPACK FOOTER //
// ./src/store/electric_load.js